import * as React from 'react';
import Slider from '@mui/material/Slider';
import {styled} from '@mui/material/styles';
import Space from "../space/Space";
import messages from "res/messages/farsi";

const MySlider = styled(Slider)({
    color: '#24c6af',
    height: 8,
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-thumb': {
        height: 24,
        width: 24,
        backgroundColor: '#24c6af',
        border: '2px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&:before': {
            display: 'none',
        },
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 12,
        background: 'unset',
        padding: 0,
        width: 32,
        height: 32,
        borderRadius: '50% 50% 50% 0',
        backgroundColor: '#24c6af',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&:before': {display: 'none'},
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(45deg)',
        },
    },
})

export default function RangeSlider(props) {

    const [selectedFirst, setSelectedFirst] = React.useState(props.selectedMin)
    const [selectedSecond, setSelectedSecond] = React.useState(props.selectedMax)

    const onChange = (event, newValue) => {
        setSelectedFirst(Math.abs(newValue[1] - props.initMax))
        setSelectedSecond(Math.abs(newValue[0] - props.initMax))
        if (props.onChange) {
            props.onChange({
                min: Math.abs(newValue[1] - props.initMax),
                max: Math.abs(newValue[0] - props.initMax)
            })
        }
    }

    const onChangeCommitted = (event, newValue) => {
        if (props.onChangeCommitted) {
            props.onChangeCommitted({
                min: Math.abs(newValue[1] - props.initMax),
                max: Math.abs(newValue[0] - props.initMax)
            })
        }
    }

    return (<div style={{position: "relative"}}>
        {props &&
        <MySlider
            min={props.initMin}
            max={props.initMax}
            value={[Math.abs(selectedSecond - props.initMax), Math.abs(selectedFirst - props.initMax)]}
            style={props.style}
            onChange={onChange}
            onChangeCommitted={onChangeCommitted}/>
        }
        <div className="horizontalScreen">
            <div className="smallTextBold" style={{position: "absolute", top: 40, right: "10%"}}>
                {messages.from + " " + selectedFirst.toLocaleString() + " " + messages.priceUnit}
            </div>
            <div className="smallTextBold" style={{position: "absolute", top: 40, left: "10%"}}>
                {messages.to + " " + selectedSecond.toLocaleString() + " " + messages.priceUnit}
            </div>
        </div>
        <Space height={"2em"}/>
    </div>)

}